export const OPS_GROUP_OPTIONS = [
  {
    slug: 'ops1',
    name: 'Ops 1',
    localizationSlug: 'OPS_1',
  },
  {
    slug: 'ops2',
    name: 'Ops 2',
    localizationSlug: 'OPS_2',
  },
  {
    slug: 'ops3',
    name: 'Ops 3',
    localizationSlug: 'OPS_3',
  },
  {
    slug: 'ops4',
    name: 'Ops 4',
    localizationSlug: 'OPS_4',
  },
  {
    slug: 'ops5',
    name: 'Ops 5',
    localizationSlug: 'OPS_5',
  },
  {
    slug: 'ops6',
    name: 'Ops 6',
    localizationSlug: 'OPS_6',
  },
  {
    slug: 'ops7',
    name: 'Ops 7',
    localizationSlug: 'OPS_7',
  },
  {
    slug: 'ops8',
    name: 'Ops 8',
    localizationSlug: 'OPS_8',
  },
  {
    slug: 'ops9',
    name: 'Ops 9',
    localizationSlug: 'OPS_9',
  },
  {
    slug: 'none',
    name: 'None',
    localizationSlug: 'NONE',
  },
];
